import { gql } from "@apollo/client";

export const INDUSTRIES_QUERY = gql`
  query industry($id: Int) {
    industry(id: $id, sort: [{ field: "name", direction: ASC }]) {
      data {
        id
        name
      }
      count
    }
  }
`;

export const NAICS_QUERY = gql`
  query naics {
    naics2012 {
      data {
        id
        name
        code
        parentId
      }
      count
    }
  }
`;

export const SIC_QUERY = gql`
  query sic {
    sicUS1987 {
      data {
        id
        name
        code
        codeStandard
        parentId
      }
      count
    }
  }
`;

export const REGION_QUERY = gql`
  query region {
    region {
      data {
        id
        name
      }
      count
    }
  }
`;

export const COUNTRY_QUERY = gql`
  query country($alpha2: String) {
    country(alpha2: $alpha2) {
      data {
        id
        alpha2
        name
        region {
          name
        }
      }
      count
    }
  }
`;

export const STATE_QUERY = gql`
  query state($countryAlpha2: String) {
    state(countryAlpha2: $countryAlpha2) {
      data {
        id
        name
      }
    }
  }
`;

// TODO - we should pull out category, attribute metadata fields to reduce payload size
export const ALL_PRODUCTS_QUERY = gql`
  query product {
    product {
      data {
        id
        name
        description
        isCloudProduct
        isOnPremiseProduct
        isMobileProduct
        vendor {
          id
          name
          url
        }
        category {
          id
          name
          nameTree
          code
        }
        attributes {
          id
          name
        }
      }
    }
  }
`;

export const ALL_VENDORS_QUERY = gql`
  query vendor {
    vendor {
      data {
        id
        name
        url
      }
    }
  }
`;

export const SIMPLIFIED_PRODUCT_ID_QUERY = gql`
  query product($ids: [Int!]!) {
    product(ids: $ids) {
      data {
        id
        name
      }
    }
  }
`;

export const PRODUCT_ID_QUERY = gql`
  query product($ids: [Int!]!) {
    product(ids: $ids) {
      data {
        id
        name
        description
        isCloudProduct
        isOnPremiseProduct
        isMobileProduct
        vendor {
          id
          name
          url
        }
        category {
          id
          name
          nameTree
          code
        }
        attributes {
          id
          name
        }
      }
      count
    }
  }
`;

export const PRODUCT_NAME_QUERY = gql`
  query product($name: String!) {
    product(name: $name, sort: [{ field: "name", direction: ASC }]) {
      data {
        id
        name
        vendor {
          name
        }
      }
      count
    }
  }
`;

export const VENDOR_ID_QUERY = gql`
  query vendor($ids: [Int!]!) {
    vendor(ids: $ids) {
      data {
        id
        name
        url
        description
      }
      count
    }
  }
`;

export const VENDOR_NAME_QUERY = gql`
  query vendor($name: String!) {
    vendor(name: $name, sort: [{ field: "name", direction: ASC }]) {
      data {
        id
        name
        url
      }
      count
    }
  }
`;

export const MENTION_ID_QUERY = gql`
  query mentionById($ids: [Int!]!) {
    mention(ids: $ids) {
      data {
        id
        name
        description
        vendor {
          id
          name
        }
      }
      count
    }
  }
`;

export const MENTION_NAME_QUERY = gql`
  query mentionByName($name: String!) {
    mention(name: $name, sort: [{ field: "name", direction: ASC }]) {
      data {
        id
        name
        description
        vendor {
          name
        }
      }
      count
    }
  }
`;

export const PRODUCT_CATEGORY_QUERY = gql`
  query category($id: Identifier) {
    category(id: $id) {
      data {
        id
        name
        parentId
        nameTree
        spendCategoryId
      }
      count
    }
  }
`;

export const SPEND_CATEGORY_QUERY = gql`
  query spendCategory {
    spendCategory {
      data {
        name
        description
        id
        parentId
        nameTree
      }
    }
  }
`;

export const DUNS_QUERY = gql`
  query duns($dunsId: Int!) {
    duns(dunsId: $dunsId) {
      dunsId
      country
      city
      companyName
      state
      streetAddress
      zipCode
    }
  }
`;

export const PRODUCT_ATTRIBUTE_QUERY = gql`
  query productAttributes {
    productAttributes(sort: [{ field: "name", direction: ASC }]) {
      count
      data {
        id
        name
        level
        description
        childrenAttributes {
          id
          name
          level
          description
        }
      }
    }
  }
`;

export const CLOUD_MATURITY_RANGE_QUERY = gql`
  query cloudMaturityRange {
    cloudMaturityRange {
      data {
        id
        displayName
        rangeMin
        rangeMax
      }
    }
  }
`;

export const GET_FAI_DEPARTMENTS_QUERY = gql`
  query GetFaiDepartments {
    faiDepartment(sort: [{ field: "name", direction: ASC }]) {
      count
      data {
        id
        name
        roles(sort: [{ field: "name", direction: ASC }]) {
          id
          name
        }
      }
    }
  }
`;

// AI Spend export columns — `exportName` is the column id covered-wagon
// selects on (it_budget_ai_*), mirroring OppGen's useGetAiSpendCategories.
export const AI_SPEND_CATEGORY_QUERY = gql`
  query spendAiCategory {
    spendAiCategory {
      data {
        name
        exportName
        id
      }
    }
  }
`;

export const FINANCING_TYPES_QUERY = gql`
  query financingTypes {
    financingTypes {
      data {
        id
        name
      }
    }
  }
`;

export const FINANCING_INVESTORS_QUERY = gql`
  query financingInvestors {
    financingInvestors {
      data {
        id
        name
        hgCompanyId
        domain
      }
    }
  }
`;
